import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
// import { useDispatch } from "react-redux";

// Route configurations
import adminRoutes from "./adminRoutes";
import authRoutes from "./authRoutes";
import userRoutes from "./userRoutes";

// Route guards
import RouteSeo from "@/seo/RouteSeo";
import AdminRoute from "./guards/AdminRoute";
import GuestRoute from "./guards/GuestRoute";
import PrivateRoute from "./guards/PrivateRoute";

// Layouts
import AdminLayout from "@/layouts/AdminLayout";
import AuthLayout from "@/layouts/AuthLayout";
import UserLayout from "@/layouts/UserLayout";

// Error pages
import Error404 from "@/shared/Error404";
import Success from "@/views/user/PaymentRes";

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-primary"></div>
  </div>
);

/**
 * Main Router Component
 * Handles all application routing with proper guards and layouts
 */
const AppRouter = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <RouteSeo />
      <Routes>
        {/* Authentication Routes */}
        {authRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <GuestRoute>
                <AuthLayout>
                  <route.element />
                </AuthLayout>
              </GuestRoute>
            }
          />
        ))}

        {/* User Routes */}
        {userRoutes.map((route) => {
          const element = route.protected ? (
            <PrivateRoute>
              <UserLayout>
                <route.element />
              </UserLayout>
            </PrivateRoute>
          ) : (
            <UserLayout>
              <route.element />
            </UserLayout>
          );

          return <Route key={route.path} path={route.path} element={element} />;
        })}

        {/* Admin Routes */}
        {adminRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <AdminRoute>
                <AdminLayout>
                  <route.element />
                </AdminLayout>
              </AdminRoute>
            }
          />
        ))}

        {/* Redirect /admin to /admin/dashboard */}
        <Route
          path="/admin"
          element={<Navigate to="/admin/dashboard" replace />}
        />

        <Route path="/result" element={<Success />} />

        {/* 404 Error Page */}
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Suspense>
  );
};

export default AppRouter;
